import { gql } from '@apollo/client';

// export const getDeliveryLocations = gql`
//   query GetDeliveryLocations($filter: DeliveryFilter, $pagination: Pagination) {
//     deliveryLocations(filter: $filter, pagination: $pagination) {
//       id
//       location
//       price
//       country
//       remarks
//       isPayOnline
//     }
//     deliveryLocationsLength(filter: $filter)
//   }
// `;

export const getDeliveryLocations = gql`
  query DeliveryLocations($filter: DeliveryFilter) {
    deliveryLocations(filter: $filter) {
      id
      location
      price
      country
      remarks
      isPayOnline
      hasInstantDelivery
      instantDeliveryPrice
    }
  }
`;
